// tslint:disable:no-submodule-imports
import * as faPause from '@fortawesome/fontawesome-free-solid/faPause';
import * as faPlay from '@fortawesome/fontawesome-free-solid/faPlay';
// tslint:enable:no-submodule-imports
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import autobind from 'class-autobind';
import * as React from 'react';
import { Button, ButtonGroup, ButtonToolbar } from 'reactstrap';
import { compose, onlyUpdateForKeys } from 'recompose';
import ToggleButton from '../../ToggleButton';
import { AnimationContextProps } from '../../types';
import withAnimationContext from '../../withAnimationContext';
import withAddDemoActivity from '../Demo/withAddDemoActivity';
import { ActivityInput, AthleteProps, SaveAthleteOptionsProps } from '../types';
import AddChartDropdown from './ActivityChart/AddChartDropdown';

const AddDemoActivityButton = withAddDemoActivity(({ addDemoActivity }) => (
    <Button
        // tslint:disable-next-line:jsx-no-lambda
        onClick={addDemoActivity}
        key="add-demo-activity"
        color="secondary"
        size="sm"
        outline={true}
    >
        Add to list of demo activities
    </Button>
));

type ActivityChartsToolbarProps = ActivityInput &
    AthleteProps &
    SaveAthleteOptionsProps;

class ActivityChartsToolbar extends React.Component<
    ActivityChartsToolbarProps & AnimationContextProps
> {
    constructor(props: ActivityChartsToolbarProps & AnimationContextProps) {
        super(props);
        autobind(this);
    }

    public render() {
        const {
            id,
            loading,
            error,
            isAnimating,
            loggedInUser,
            activityStreamInfoList,
            addActivityStream
        } = this.props;

        const isAdministrator = !!(
            loggedInUser &&
            loggedInUser.user &&
            loggedInUser.user.isAdministrator
        );

        const athleteProps = {
            activityStreamInfoList,
            addActivityStream,
            error,
            loading,
            loggedInUser
        };

        const athlete =
            loggedInUser && loggedInUser.user && loggedInUser.user.athlete;
        const autoplayAnimation = athlete ? athlete.autoplayAnimation : false;

        return (
            <div
                className="add-chart-container w-100"
                key="add-chart-container"
            >
                <ButtonToolbar>
                    <AddChartDropdown
                        id={id}
                        key="add-chart"
                        {...athleteProps}
                    />

                    <ButtonGroup>
                        <Button
                            id={`play-button`}
                            color="secondary"
                            outline={true}
                            size="sm"
                            disabled={isAnimating || loading || error}
                            onClick={this.handlePlayAnimation}
                        >
                            <FontAwesomeIcon icon={faPlay} className="" />
                        </Button>

                        <Button
                            id={'pause-button'}
                            color="secondary"
                            outline={true}
                            size="sm"
                            disabled={!isAnimating || loading || error}
                            onClick={this.handlePauseAnimation}
                        >
                            <FontAwesomeIcon icon={faPause} className="" />
                        </Button>
                    </ButtonGroup>
                    <div>
                        <p className="d-inline small text-muted mr-1">
                            Autoplay
                        </p>
                        <div className="d-inline">
                            <ToggleButton
                                value={!!autoplayAnimation}
                                onToggle={this.handleToggleAutoplay}
                            />
                        </div>
                    </div>

                    {isAdministrator ? <AddDemoActivityButton id={id} /> : null}
                </ButtonToolbar>
            </div>
        );
    }

    private handlePlayAnimation() {
        const { onAnimationChanged } = this.props;
        onAnimationChanged && onAnimationChanged({ isAnimating: true });
    }

    private handleToggleAutoplay(value: boolean) {
        const { toggleAutoplayAnimation } = this.props;
        toggleAutoplayAnimation && toggleAutoplayAnimation(!value);
    }

    private handlePauseAnimation() {
        const { onAnimationChanged } = this.props;
        onAnimationChanged && onAnimationChanged({ isAnimating: false });
    }
}

export default compose<
    ActivityChartsToolbarProps & AnimationContextProps,
    ActivityChartsToolbarProps
>(
    withAnimationContext,
    // We don't want to update for every animation frame
    onlyUpdateForKeys(['loggedInUser', 'id', 'error', 'loading', 'isAnimating'])
)(ActivityChartsToolbar);



// WEBPACK FOOTER //
// ./src/client/components/Strava/ActivityScene/ActivityChartsToolbar.tsx